// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "sendAgain-3w2ZW";
var _4 = "sendAgain__link-3il0C";
var _5 = "label-2DmFY";
var _6 = "item-2PTJH";
var _7 = "timer-uQ_Nb";
var _8 = "timer__time-1FmJD";
var _9 = "sending-3lq50";
var _a = "rotation-2zFCF";
var _b = "sent-lfmjU";
var _c = "back-Gwkmp";
export { _1 as "__esModule", _2 as "mobile", _3 as "sendAgain", _4 as "sendAgain__link", _5 as "label", _6 as "item", _7 as "timer", _8 as "timer__time", _9 as "sending", _a as "rotation", _b as "sent", _c as "back" }
export default { "__esModule": _1, "mobile": _2, "sendAgain": _3, "sendAgain__link": _4, "label": _5, "item": _6, "timer": _7, "timer__time": _8, "sending": _9, "rotation": _a, "sent": _b, "back": _c }
